export const TABLE_FORMATS = {
    MONEY: 'money',
    UNIT: 'unit',
    PERCENTAGE: 'percentage',
    TIMESTAMP: 'timestamp',
    PREFIX: 'prefix',
    BOOLEAN: 'boolean',
    JSON_PATH: 'json_path',
    INPUT: 'input',
    TOOLTIP: 'tooltip',
    FORMAT: 'format',
    CUSTOM: 'custom',
    ICON_TOOLTIP: 'icon_tooltip',
    CHIP: 'chip',
};

export const PAGE_SIZE_OPTIONS = [6, 10, 20, 50, 100, 500, 1000];

export const SORT_DIRECTION = {
    ASC: 'asc',
    DESC: 'desc',
    NONE: null
};
